import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';

export default function rescheduleeasonsList(component){
  const Authorization='bearer '+localStorage.getItem('token');
  fetch(`${API_URL}rest/V1/picker/getReasons`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
      body:JSON.stringify({
        user_type:"rider",
        reason_type:"reschedule"
        })
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
            return response.json();
        })
        .then(function(data) {
            console.log("rescheduleReasonAction",data);
            component.props.rescheduleReasonAction(data);
    })
}



// WEBPACK FOOTER //
// ./src/utility/api/getscheduleReasons.js